import React from "react";
import PropTypes from "prop-types";
import lstrings from "../../../../../utils/LStrings";
import { Panel, Button, Col, Row, Alert } from "react-bootstrap";
import ScrollableAnchor from "react-scrollable-anchor";
import IncomeIndicator from "./panel-veraz/components/IncomeIndicator";
import ScoreIndicator from "./panel-veraz/components/ScoreIndicator";
import ObsDetails from "./panel-veraz/components/ObsDetails";

import PermissionChecker from "../../../../../components/permission-checker/PermissionChecker";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import "./PanelVeraz.css";

class PanelVeraz extends React.Component {
	constructor(props) {
		super(props);

		this.setIncomeIndicatorLeftMargin = this.setIncomeIndicatorLeftMargin.bind(this);
		this.handleErrorDismiss = this.handleErrorDismiss.bind(this);
		this.handleErrorShow = this.handleErrorShow.bind(this);
		this.handleRetry = this.handleRetry.bind(this);

		this.state = {
			showError: false,
			error: false,
			showCategoria: false,
			categoriaTitle: undefined,
			categoriaText: undefined,
			errorText: undefined,
			scorePosition: null,
			showScore: false,
			showIncome: false,
			showObs: false,
			showVerazLogo: false,
			callToAction: false,
			incomeIndicatorLeftMargin: 0,
		};
	}

	onRequestInfo = (infoKey, infoTitle) => {
		this.props.onRequestInfo(lstrings.panelVerazTitle, lstrings.verazInfoTitle);
	};

	/**
	 * Calculo el margen que debo configurar para centrar el gráfico.
	 * El ancho del gráfico varía dependiendo del rango de ingresos de la persona.
	 * 
	 * @param {Number} indicatorWidth 
	 * @returns 
	 */
	setIncomeIndicatorLeftMargin(indicatorWidth) {
		// maxWidth = 170px
		let leftMargin = 0
		if (indicatorWidth < 170) {
			leftMargin = 170 - indicatorWidth;
		}

		this.setState({ incomeIndicatorLeftMargin: leftMargin });
	}

	componentDidMount() {
		this.updateState(this.props)
	}

	componentWillReceiveProps(nextProps) {
		this.updateState(nextProps)
	}

	handleErrorDismiss() {
		this.setState({ showError: false });
	}

	handleErrorShow() {
		this.setState({ showError: true });
	}

	handleRetry() {
		this.props.onRetry(true);
	}

	updateState = (props) => {
		const veraz = props.info;
		if (veraz) {
			if (veraz.ok === true) {
				this.setState({
					error: false,
					errorText: undefined,
				});
			} else {
				this.setState({
					error: true,
					errorText: veraz.mensaje,
				});
			}
			if (veraz.scoreRango != undefined) {
				this.setState({
					showVerazLogo: true,
					showScore: true,
					scorePosition: veraz.scoreRango,
					scoreLabel: veraz.scoreSegmento,
					scoreLegend: veraz.scoreTexto,
				});
			}
			if (veraz.incomePredictor != undefined) {
				this.setState({
					showVerazLogo: true,
					showIncome: true,
					incomePredictor: veraz.incomePredictor,
					incomePredictorRango: veraz.incomePredictorRango,
					incomePredictorRangoList: veraz.incomePredictorRangoList,
				});
			}
			if (veraz.cantObsVigBa24m != undefined) {
				this.setState({
					showObs: true,
					cantObs: veraz.cantObsVigBa24m,
					montoObs: veraz.montoObsVigBa24m,
					detalleObs: veraz.obsVigentesBa,
				});
			}
			if (veraz.tokenCA != undefined && veraz.mensaje === null) {
				this.setState({
					callToAction: true,
					token: veraz.tokenCA
				});
			} else {
				this.setState({
					callToAction: false,
					token: null
				});
			}
			if (veraz.categoria != undefined) {
				this.setState({
					showCategoria: true,
					categoriaTitle: veraz.categoria,
					categoriaText: veraz.mensaje,
				});
			}
			return;
		}
	};

	render() {
		let titulo = (
			<h2>
				<i className="fa fa-user"></i> {lstrings.panelVerazTitle}
			</h2>
		);

		return (
			<ScrollableAnchor id={"panel-veraz"}>
				<Panel collapsible defaultExpanded header={titulo}>
					<PermissionChecker
						infoKey="veraz"
						infoTitle=""
						data={this.props.info}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}
						callToAction={this.state.callToAction}
					>
						{this.state.error &&
							<Row>
								<Col sm={6} smOffset={3} md={4} mdOffset={4}>
									{!this.state.showError && <Button
										bsStyle="danger"
										onClick={this.handleErrorShow}
									>
										Ocurrió un Error. Haga clic para más información...
									</Button>
									}
									{this.state.showError && <Alert
										bsStyle="danger"
										onDismiss={this.handleErrorDismiss}
									>
										<p>
											{this.state.errorText}
											<Button bsStyle="link" onClick={this.handleRetry}>
												<i className="fa fa-repeat"></i> Reintentar
											</Button>
										</p>

									</Alert>
									}
								</Col>
							</Row>
						}
						{this.state.showCategoria &&
							<Row>
								<Col sm={6} smOffset={3} md={4} mdOffset={4}>
									<Panel header={this.state.categoriaTitle} bsStyle="warning">
										<p>
											{this.state.categoriaText}
										</p>
									</Panel>
								</Col>
							</Row>
						}
						<Row>
							{this.state.showScore && (
								<Col sm={12} md={4} lg={6}>
									<div>
										<h4 className="text-center">
											{lstrings.verazScoreTitle}
										</h4>
										<Row>
											<Col lg={10} lgOffset={1}>
												<p>{lstrings.verazScoreDescription}</p>
											</Col>
										</Row>
									</div>
									<div className="text-center">
										<div className="score-indicator">
											<ScoreIndicator
												position={
													this.state.scorePosition
												}
												label={this.state.scoreLabel}
												legend={this.state.scoreLegend}
												updateScoreExplanationPdf={this.props.updateScoreExplanationPdf}
											/>
										</div>
									</div>
								</Col>
							)}
							{this.state.showIncome && (
								<Col sm={12} md={4} lg={2} className="mb-2">
									<div className="text-center">
										<h4>{lstrings.verazIngresosTitle}</h4>
									</div>
									<div className="text-center">
										<div className="income-indicator">
											<IncomeIndicator
												incomePredictor={
													this.state.incomePredictor
												}
												incomePredictorRango={
													this.state.incomePredictorRango
												}
												incomePredictorRangoList={
													this.state.incomePredictorRangoList
												}
												onWidthChange={
													this.setIncomeIndicatorLeftMargin
												}
											/>
										</div>
									</div>
								</Col>
							)}
							{this.state.showObs && (
								<Col sm={8} smPush={2} md={4} mdPush={0} lg={4} lgPush={0}>
									<ObsDetails
										detalleObs={this.state.detalleObs}
										cantObs={this.state.cantObs}
										montoObs={this.state.montoObs}
									/>
								</Col>
							)}
						</Row>
					</PermissionChecker>
				</Panel>
			</ScrollableAnchor>
		);
	}
}

PanelVeraz.propTypes = {
	info: PropTypes.object.isRequired,
	onRequestInfo: PropTypes.func,
	onRetry: PropTypes.func,
	hidePanels: PropTypes.any,
	updateScoreExplanationPdf: PropTypes.func,
};

export default PanelVeraz;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelVeraz.js